module.exports = __webpack_public_path__ + "media/images/constellation-bg-a2ba6147.jpg";